import { useMemo } from 'react';
import { useUserInfo } from './useUserInfo';

const useGates = () => {
  const userInfo = useUserInfo();

  const gates = useMemo(() => new Set(userInfo?.gates), [userInfo]);

  return gates;
};

export const useGate = (gate: string) => useGates().has(gate);
